import type { CategoryCurrentRefinement, CategoryCurrentRefinementGroup } from '@/components/category-search/CategoryCurrentRefinements';
import { categorySearchStore } from '@/stores/category/CategorySearchStore';
import _ from 'lodash';

export function useCategorySearchSelectedFiltersSync() {
    const searchStore = categorySearchStore();

    const syncSelectedFilters = (items: CategoryCurrentRefinementGroup[]): true => {
        const newFilters: Record<string, string> = {};

        items.forEach((item: CategoryCurrentRefinementGroup) => {
            item.refinements.forEach((refinement: CategoryCurrentRefinement) => {
                newFilters[refinement.attribute] = refinement.value;
            });
        });

        searchStore.selectedFilters = newFilters;
        searchStore.refinementKey = _.sortBy(
            _.flatMap(items, (item: CategoryCurrentRefinementGroup) =>
                _.map(item.refinements, (refinement: CategoryCurrentRefinement) => `${refinement.attribute}:${refinement.value}`),
            ),
        ).join('|');

        return true;
    };

    return { syncSelectedFilters };
}
